window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.selectchoices-remote').length) {
    import('./_choices-remote.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
